module.exports = __webpack_public_path__ + "static/media/apr 2021.33445cfa.svg";